import { render, staticRenderFns } from "./landStatictics.vue?vue&type=template&id=5761ba27&scoped=true&"
import script from "./landStatictics.vue?vue&type=script&lang=js&"
export * from "./landStatictics.vue?vue&type=script&lang=js&"
import style0 from "./landStatictics.vue?vue&type=style&index=0&id=5761ba27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5761ba27",
  null
  
)

export default component.exports